import NotFoundError from './NotFoundError'
import UnknownError from './UnknownError'

export type ErrorTemplateProps = {
  code: string
  message?: string
}

export function ErrorTemplate(props: ErrorTemplateProps) {
  const { code, message } = props

  switch (code) {
    case 'NotFoundError':
      return <NotFoundError message={message} />
    default:
      return <UnknownError />
  }
}

export default ErrorTemplate
